import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import TeamMemberCard from '@/common/interfaces/modules/TeamMemberCard';
import { ImageSizes, ImageSize } from '@/common/interfaces/SizeBreakpoints';
import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage.vue';
import { Swiper, SwiperSlide, SwiperOptions} from '@/utils/swiperUtils';
import { SegmentElement } from '@/plugins/utm/SegmentElement';
import SwiperMixin from '@/mixins/SwiperMixin';

const ArticleAuthorProps = Vue.extend({
  props: {
    cards: Array as () => TeamMemberCard[],
    isCardLandscape: Boolean,
    id: String
  },
});

@Component({
  components: {
    ResponsiveImage,
    Swiper,
    SwiperSlide,
  },
  mixins: [SwiperMixin]
})

export default class ArticleAuthor extends ArticleAuthorProps {
  ImageSizesThumbnail: ImageSizes = {
    def: new ImageSize([210, 210]),
    sizes: {
      md: new ImageSize([210, 210]),
    },
  };

  swiperOption: SwiperOptions = {
    slidesPerView: 1,
    effect: 'fade',
    pagination: {
      el: `#c-${this.id}-swiper-pagination`,
      type: 'bullets',
      clickable: true,
    },
    fadeEffect: {
      crossFade: true,
    },
  };

  get IsArticleAuthorEmpty () {
    const isSingle = this.cards.length === 1;
    if (isSingle) {
      const card = this.cards[0];
      return card.Image === null && card.Text === null;
    }
  }

  get hasSomeAuthorPhoto() {
    return this.cards.some(card => card.Image?.Url)
  }

  onModuleInteraction() {
    const module = this.$el.closest('*[contentlinkid]');
    SegmentElement.sendEvent('moduleInteraction', {
      component_name: 'ArticleAuthor',
      module_type_id: module.getAttribute('data-segmentid'),
      module_type_name: module.getAttribute('type'),
      interaction_type: 'carousel',
      // @ts-ignore
      position: this.swiper.activeIndex + 1,
    })
  }
}
